var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ListService } from '../list/list.service';
import { ConditionService } from '../../service/condition.service';
var PredicateList = /** @class */ (function () {
    function PredicateList() {
        this.predicateList = [];
    }
    return PredicateList;
}());
export { PredicateList };
var MemberQuery = /** @class */ (function () {
    function MemberQuery() {
        this.limit = 10;
        this.page = 1;
        this.orderByList = [];
        this.searchConditionList = [];
    }
    return MemberQuery;
}());
export { MemberQuery };
var RequestMemberQuery = /** @class */ (function () {
    function RequestMemberQuery() {
        this.limit = 10;
        this.offset = 0;
        this.orderByList = [];
        this.searchConditionList = [];
    }
    return RequestMemberQuery;
}());
export { RequestMemberQuery };
var DispSearchCond = /** @class */ (function () {
    function DispSearchCond() {
    }
    return DispSearchCond;
}());
export { DispSearchCond };
var DispCategory = /** @class */ (function () {
    function DispCategory() {
    }
    return DispCategory;
}());
export { DispCategory };
var DispPredicate = /** @class */ (function () {
    function DispPredicate() {
    }
    return DispPredicate;
}());
export { DispPredicate };
var Option = /** @class */ (function () {
    function Option() {
    }
    return Option;
}());
export { Option };
var MemberSearchService = /** @class */ (function (_super) {
    __extends(MemberSearchService, _super);
    function MemberSearchService(logger, api, cond) {
        var _this = _super.call(this, logger, api, cond) || this;
        _this.logger = logger;
        _this.api = api;
        _this.cond = cond;
        _this.baseUrl = '/v1/member-search';
        _this.searchVal = {};
        _this.searchConditionList = [];
        _this.baseGroupName = '$memberSearchGroup';
        _this.condListNo = 1; // 検索条件 xx として保存
        _this.condList = {}; // 保存済み検索条件一覧 検索・表示データ保持
        _this.memberQuery = new MemberQuery();
        _this._subjectCondList = new BehaviorSubject(_this._data);
        _this._subjectEditCond = new BehaviorSubject(_this._data);
        return _this;
    }
    MemberSearchService.prototype.setInit = function () {
        _super.prototype.initQuery.call(this);
        this.memberQuery = new MemberQuery();
        this.searchVal = {};
        this.searchConditionList = [];
        this.condList = {};
        this.condListNo = 1;
        this._subjectCondList.next();
        this._subjectEditCond.next();
        var cond = this.getCondition();
        if (typeof cond !== 'undefined') {
            var val = cond.searchRec;
            this.setSearchVal(val.condition, val.options, val.types, val.operators, val.toggles, val.condListNo);
            this.setSearchConditionList(cond['searchConditionList']);
            this.condList = cond['condList'] || {};
            if (Object.keys(this.condList).length > 0) {
                this.condListNo = Object.keys(cond['condList']).length + 1;
            }
            this._subjectCondList.next(this.condList);
        }
    };
    MemberSearchService.prototype.setBaseUrl = function (url) {
        _super.prototype.setBaseUrl.call(this, url);
    };
    MemberSearchService.prototype.convertMemberQuery = function (query) {
        return {
            limit: query.limit,
            offset: (query.page - 1) * query.limit,
            orderByList: query.orderByList,
            searchConditionList: query.searchConditionList
        };
    };
    MemberSearchService.prototype.getMemberQuery = function (query) {
        if (query === void 0) { query = {}; }
        _super.prototype.getQuery.call(this, query, _super.prototype.getGroupName.call(this));
        if (typeof query !== 'undefined') {
            for (var key in this.memberQuery) {
                if (typeof query[key] !== 'undefined') {
                    this.memberQuery[key] = query[key];
                    if (key === 'searchConditionList') {
                        this.setCondition(query[key], key);
                    }
                }
            }
        }
        this.logger.debug('q:', this.convertMemberQuery(this.memberQuery));
        return this.convertMemberQuery(this.memberQuery);
    };
    MemberSearchService.prototype.getCurrentMemberQuery = function () {
        return {
            limit: this.memberQuery.limit,
            page: this.memberQuery.page,
            orderByList: this.memberQuery.orderByList,
            searchConditionList: this.memberQuery.searchConditionList
        };
    };
    // リスト取得
    MemberSearchService.prototype.getSelectOption = function (cond, id) {
        var param = {};
        if (typeof cond !== 'undefined') {
            param['condition'] = cond;
        }
        if (typeof id !== 'undefined') {
            param['parent_id'] = id;
        }
        return this.api.get('/v1/get-member-search-condition-list', param);
    };
    // 紐づけ用セグメントセットリスト取得
    // 施策利用中セグメントセットには紐づけ不可
    MemberSearchService.prototype.getSegmentSetRecord = function () {
        //return this.api.get('/v1/gen/segment-m-service');
        return this.api.get('/v1/gen/segment-set-m-service-regist-api?query={"predicateList":[ {"name":"campaign_m.campaign_id","operator":"isNull"} ]}');
    };
    // セグメント生成
    // セグメントセットとして保存も可
    MemberSearchService.prototype.createSegmentSetRecord = function (rec) {
        this.logger.debug('createSegmentSetRecord:', rec);
        return this.api.post('/v1/gen/segment-m-service', rec);
    };
    // 検索条件保存
    MemberSearchService.prototype.createRecord = function (rec) {
        this.logger.debug('createRecord:', rec);
        return this.api.post('/v1/gen/member-search-condition-m-service', rec);
    };
    // トリガー生成
    MemberSearchService.prototype.createTrigger = function (rec) {
        this.logger.debug('createTrigger:', rec);
        return this.api.post('/v1/gen/trigger-cond-service', rec);
    };
    // 検索条件設定のデータを保持
    MemberSearchService.prototype.setSearchVal = function (condition, options, types, operators, toggles, condListNo) {
        if (condition === void 0) { condition = {}; }
        if (options === void 0) { options = {}; }
        if (types === void 0) { types = {}; }
        if (operators === void 0) { operators = {}; }
        if (toggles === void 0) { toggles = {}; }
        if (condListNo === void 0) { condListNo = 1; }
        this.searchVal = {
            condition: condition,
            options: options,
            types: types,
            operators: operators,
            toggles: toggles,
            condListNo: condListNo
        };
        this.logger.debug('searchVal:', this.searchVal);
        this.setCondition(this.searchVal);
    };
    MemberSearchService.prototype.getSearchVal = function () {
        return this.searchVal;
    };
    // 検索実行のときsearchConditionListを保持
    MemberSearchService.prototype.getSearchConditionList = function () {
        return this.searchConditionList;
    };
    MemberSearchService.prototype.setSearchConditionList = function (searchConditionList) {
        this.logger.debug('@@@ setPredicateList:', searchConditionList);
        this.searchConditionList = searchConditionList;
    };
    Object.defineProperty(MemberSearchService.prototype, "observableCondList", {
        // 保存済み検索条件一覧用
        // 検索条件として保存→保存済み検索条件一覧に表示
        get: function () {
            return this._subjectCondList.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    // 保存済み検索条件一覧に表示するデータを取得
    MemberSearchService.prototype.getDispCondList = function (no, query) {
        if (query === void 0) { query = {}; }
        this.logger.debug('===== member_search service getDispCondList');
        var _query = new MemberQuery();
        for (var _i = 0, _a = Object.keys(_query); _i < _a.length; _i++) {
            var key = _a[_i];
            if (typeof query[key] !== 'undefined') {
                _query[key] = query[key];
            }
        }
        this.logger.debug('q:', this.convertMemberQuery(_query));
        return this.api.post(this.baseUrl, this.convertMemberQuery(_query));
    };
    // 検索条件 xx として保存
    MemberSearchService.prototype.getCondListNo = function () {
        return this.condListNo;
    };
    MemberSearchService.prototype.setCondListNo = function () {
        this.condListNo = this.condListNo + 1;
    };
    // 保存済み検索条件一覧のデータを保持
    MemberSearchService.prototype.getCondList = function (no) {
        if (no === void 0) { no = 0; }
        if (no > 0) {
            return this.condList['cond' + no];
        }
        else {
            return this.condList;
        }
    };
    MemberSearchService.prototype.setCondList = function (no, condition, options, types, operators, predicateList, disp) {
        if (condition === void 0) { condition = {}; }
        if (options === void 0) { options = {}; }
        if (types === void 0) { types = {}; }
        if (operators === void 0) { operators = {}; }
        if (predicateList === void 0) { predicateList = {}; }
        if (disp === void 0) { disp = {}; }
        var mode = 'add';
        var list = {};
        var cond = {
            no: no,
            query: {
                condition: condition,
                options: options,
                types: types,
                operators: operators,
            },
            predicateList: predicateList,
            disp: disp
        };
        if (typeof this.condList['cond' + no] === 'undefined') {
            // add
            this.setCondListNo();
            cond = Object.assign(cond, { enable: true, operator: 'and', index: no - 1 });
        }
        else {
            //update
            mode = 'update';
            list['no'] = this.condList['cond' + no]['no'];
            list['enable'] = this.condList['cond' + no]['enable'];
            list['operator'] = this.condList['cond' + no]['operator'];
            list['index'] = this.condList['cond' + no]['index'];
        }
        this.condList['cond' + no] = $.extend(true, {}, list, cond);
        this.setCondition(this.condList, 'condList');
        // 保存済み検索条件一覧に表示
        this._subjectCondList.next({ mode: mode, cond: this.condList['cond' + no] });
    };
    MemberSearchService.prototype.setCondListParam = function (no, property, value) {
        this.condList['cond' + no][property] = value;
        this.setCondition(this.condList, 'condList');
    };
    Object.defineProperty(MemberSearchService.prototype, "observableEditCond", {
        // 保存済み検索条件一覧で編集クリック→検索条件設定に展開
        get: function () {
            return this._subjectEditCond.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MemberSearchService.prototype.setEditCond = function (no) {
        this._subjectEditCond.next(this.condList['cond' + no]);
    };
    MemberSearchService.prototype.setCondition = function (data, key) {
        if (data === void 0) { data = {}; }
        if (key === void 0) { key = 'searchRec'; }
        _super.prototype.setCondition.call(this, data, _super.prototype.getGroupName.call(this), key);
    };
    MemberSearchService.prototype.getCondition = function () {
        return _super.prototype.getCondition.call(this, _super.prototype.getGroupName.call(this));
    };
    MemberSearchService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MemberSearchService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ConditionService }
    ]; };
    return MemberSearchService;
}(ListService));
export { MemberSearchService };
//# sourceMappingURL=member_search.service.js.map